import {fontWeight, colorPalette, fontSize} from '../../../config';
import {
	cardTitleProps,
	ulsTitleProps,
	ulsContentProps,
	tdProps,
	thProps,
} from '../../common';
import {programImg} from '../../../config/images';

export const summary = {
	title: {
		text: {...cardTitleProps, children: '대회개요'},
	},
	uls: [
		{
			listStyle: 'title',
			items: [
				{
					title: {...ulsTitleProps, children: '대회명'},
					content: {
						...ulsContentProps,
						children: '제1회 10.19 평화마라톤',
						fontWeight: fontWeight.extraBold,
					},
				},
				{
					title: {...ulsTitleProps, children: '일시'},
					content: {
						...ulsContentProps,
						children: '2025년 10월 19일(일) 09:00 출발',
					},
				},
				{
					title: {...ulsTitleProps, children: '접수마감'},
					content: {
						...ulsContentProps,
						children:
							'2025년 9월 28일(일) 24:00까지\n*3,000명 선착순 마감으로, 공식 마감 전 조기마감될 수 있습니다. ',
					},
				},
				{
					title: {...ulsTitleProps, children: '장소'},
					content: {
						...ulsContentProps,
						children: '여수 진남경기장 주경기장',
					},
				},
				{
					title: {...ulsTitleProps, children: '종목'},
					contents: [
						{
							...ulsContentProps,
							children:
								'10.19km / 5km (2개 종목 합산 선착순 3,000명)',
						},
					],
				},
				{
					title: {...ulsTitleProps, children: '참가비'},
					content: {
						...ulsContentProps,
						children: `- 10.19km코스(35,000원)\n- 5km코스(20,000원)`,
					},
				},
				{
					title: {...ulsTitleProps, children: '참가자격'},
					contents: [
						{
							...ulsContentProps,
							children: '나이제한 없으며, 신체 건강한 남/여',
						},
						{
							...ulsContentProps,
							children:
								'장소와 주로가 협소하므로 안전을 위해 부득이하게 휠체어, 유모차, 애견동반이 금지됩니다.',
						},
						{
							...ulsContentProps,
							children: `대한육상경기연맹 등록선수 및 선수등록 말소 후 2년 경과되지 않은 자는 참가할 수 없습니다.`,
							fontWeight: fontWeight.bold,
						},
					],
				},
				{
					title: {...ulsTitleProps, children: '문의'},
					content: {
						...ulsContentProps,
						children: `사무국 연락처 : 061-921-9900, 팩스 : 061-921-9906\n사무국 운영시간/09:00~18:00(월~금), 점심시간/12:00~13:00, 공휴일 휴무`,
					},
				},
				{
					title: {...ulsTitleProps, children: '주최'},
					content: {
						...ulsContentProps,
						children: '10.19 평화마라톤 추진위원회',
					},
				},
				{
					title: {...ulsTitleProps, children: '주관'},
					content: {
						...ulsContentProps,
						children: '뉴스탑전남',
					},
				},
			],
		},
	],
};

export const way = {
	title: {
		text: {...cardTitleProps, children: '신청방법'},
	},
	uls: [
		{
			listStyle: 'title',
			items: [
				{
					title: {...ulsTitleProps, children: '인터넷'},
					content: {
						...ulsContentProps,
						children: 'ys1019.kr',
						fontWeight: fontWeight.bold,
					},
				},
				// {
				// 	title: {...ulsTitleProps, children: '현장접수'},
				// 	content: {
				// 		...ulsContentProps,
				// 		children: `-`,
				// 		color: colorPalette.neonbtn,
				// 		fontWeight: fontWeight.bold,
				// 	},
				// },
			],
		},
	],
};

export const feeTextProps = {
	base: {
		fontWeight: fontWeight.medium,
		color: colorPalette.white,
		fontSize: {desktop: fontSize.xl},
	},
	accent: {
		fontWeight: fontWeight.bold,
		color: colorPalette.white,
		fontSize: {desktop: fontSize.xl3},
	},
};

export const fee = {
	display: {
		desktop: 'table',
		tablet: 'table',
		mobile: 'none',
	},
	title: {
		text: {
			...cardTitleProps,
			children: (
				<>
					참가비 및 입금계좌
					<span
						style={{
							fontSize: '16px',
							color: colorPalette.accent,
							fontWeight: fontWeight.medium,
							marginLeft: '25px',
						}}
					>
						접수기간 내 환불요청 시 참가비 10%를 제외한 금액 환불.
						자세한 사항은 유의사항 확인
					</span>
				</>
			),
		},
	},
	table: {
		display: {
			desktop: 'table',
			tablet: 'table',
			mobile: 'none',
		},
		scroll: false,
		ths: [
			{...thProps, children: '종목'},
			{...thProps, children: '참가비'},
			{...thProps, children: '입금계좌'},
		],
		trs: [
			[
				{...tdProps, children: '10.19km'},
				{...tdProps, children: '35,000'},
				{
					...tdProps,
					childrens: [
						// {
						// 	...feeTextProps.base,
						// 	children:
						// 		'입금은행 :  OO / 예금주:  OOOOO',
						// },
						// {
						// 	...feeTextProps.accent,
						// 	children: '00-0000-00000',
						// },
						{
							...feeTextProps.base,
							children: '10.19 평화마라톤 추진위원회',
						},
						{
							...feeTextProps.accent,
							children: '농협 301-0373-4099-41',
						},
					],
					rowSpan: '2',
				},
			],
			[
				{...tdProps, children: '5km'},
				{...tdProps, children: '20,000'},
			],
			// [
			// 	{...tdProps, children: '10.19km'},
			// 	{...tdProps, children: '20,000'},
			// ],
			// [
			// 	{...tdProps, children: '5km'},
			// 	{...tdProps, children: '10,000'},
			// ],
		],
	},
};

export const mobileFee = {
	display: {
		desktop: 'none',
		tablet: 'none',
		mobile: 'table',
	},
	title: {
		text: {
			...cardTitleProps,
			children: (
				<>
					참가비
					<span
						style={{
							fontSize: '15px',
							color: colorPalette.accent,
							fontWeight: fontWeight.medium,
							marginLeft: '15px',
						}}
					>
						접수기간 내 환불요청 시 참가비 10%를 제외한 금액 환불.
						자세한 사항은 유의사항 확인
					</span>
				</>
			),
		},
	},
	table: {
		display: {
			desktop: 'none',
			tablet: 'none',
			mobile: 'table',
		},
		scroll: false,
		ths: [
			{...thProps, children: '종목'},
			{...thProps, children: '참가비'},
		],
		trs: [
			// [
			// 	{...tdProps, children: '풀코스'},
			// 	{...tdProps, children: '35,000'},
			// ],
			// [
			// 	{...tdProps, children: '하프코스'},
			// 	{...tdProps, children: '30,000'},
			// ],
			[
				{...tdProps, children: '10.19km'},
				{...tdProps, children: '35,000'},
			],
			[
				{...tdProps, children: '5km'},
				{...tdProps, children: '20,000'},
			],
		],
	},
};

export const mobileDeposit = {
	display: {
		desktop: 'none',
		tablet: 'none',
		mobile: 'table',
	},
	title: {
		text: {
			...cardTitleProps,
			children: (
				<>
					입금계좌
					<span
						style={{
							fontSize: '15px',
							color: colorPalette.accent,
							fontWeight: fontWeight.medium,
							marginLeft: '15px',
						}}
					>
						접수기간 내 환불요청 시 참가비 10%를 제외한 금액 환불.
						자세한 사항은 유의사항 확인
					</span>
				</>
			),
		},
	},
	table: {
		display: {
			desktop: 'none',
			tablet: 'none',
			mobile: 'table',
		},
		scroll: false,
		ths: [{...thProps, children: '입금계좌'}],
		trs: [
			[
				{
					...tdProps,
					childrens: [
						// {
						// 	...feeTextProps.base,
						// 	children:
						// 		'입금은행 :  OO / 예금주:  OOOOO',
						// },
						// {
						// 	...feeTextProps.accent,
						// 	children: '00-0000-00000',
						// },
						{
							...feeTextProps.base,
							children: '10.19 평화마라톤 추진위원회',
						},
						{
							...feeTextProps.accent,
							children: '농협 301-0373-4099-41',
						},
					],
				},
			],
		],
	},
};
export const programsEvents = {
	title: {
		text: {...cardTitleProps, children: '프로그램 및 이벤트'},
	},
	image: {src: programImg},
};
// export const refundPolicy = {
// 	title: {
// 		text: {...cardTitleProps, children: '환불규정'},
// 	},
// 	uls: [
// 		{
// 			listStyle: 'circle',
// 			items: [
// 				{
// 					content: {
// 						...ulsContentProps,
// 						children:
// 							'접수 마감 후에는 어떠한 경우에도 환불이 불가능하니 이점 유의하여 주시기 바랍니다.',
// 					},
// 				},
// 				{
// 					content: {
// 						...ulsContentProps,
// 						children: `참가 취소시 환불 받고자 하는 통장의 정보(은행, 예금주, 계좌번호)가 필요하오니, 정확한 정보를 환불게시판에 입력해 주시기 바랍니다.`,
// 					},
// 				},
// 				{
// 					content: {
// 						...ulsContentProps,
// 						children: `천재지변이나 국가 재난사태(질병, 국가적 재난 등 사회적 분위기로 대회 개최가 어렵다고 판단되는 경우, 구제역이나 AI 발생 등으로 국가적으로 집회 등에 대한 자제 요청이 있을 경우)로 인한 대회 취소 시, 참가비는 전액 반환되지 않습니다.`,
// 					},
// 				},
// 				// {
// 				// 	content: {
// 				// 		...ulsContentProps,
// 				// 		children:
// 				// 			'공식 접수마감 이후 취소나 종목 변경 불가 (연장접수기간 취소 및 환불 불가)',
// 				// 	},
// 				// },
// 				// {
// 				// 	content: {
// 				// 		...ulsContentProps,
// 				// 		children:
// 				// 			'접수마감 전 취소시 10% 공제 후 환불 (환불 소요기간은 약 1 주일 소요)',
// 				// 	},
// 				// },
// 				// {
// 				// 	content: {
// 				// 		...ulsContentProps,
// 				// 		children:
// 				// 			'참가자가 본인 이름으로 입금하지 않아, 입금 확인이 되지 않을 경우, 참가할 수 없으며 입금 금액의 10% 를 공제한 후 환불 (환불 소요기간은 약 1 주일 소요)',
// 				// 	},
// 				// },
// 			],
// 		},
// 		{
// 			listStyle: 'title',
// 			items: [
// 				{
// 					title: {
// 						...ulsTitleProps,
// 						children: '환불 신청 기간',
// 						type: 'long',
// 					},
// 					content: {
// 						...ulsContentProps,
// 						children:
// 							'참가 접수기간 중에만 가능 (공식 참가 신청 마감일 이후에는 불가능)',
// 					},
// 				},
// 				{
// 					title: {
// 						...ulsTitleProps,
// 						children: '환불 신청방법',
// 						type: 'long',
// 					},
// 					content: {
// 						...ulsContentProps,
// 						children: '홈페이지 환불게시판에 직접 신청',
// 					},
// 				},
// 				{
// 					title: {
// 						...ulsTitleProps,
// 						children: '환불액 지급 방법',
// 						type: 'long',
// 					},
// 					content: {
// 						...ulsContentProps,
// 						children:
// 							'개인 계좌를 통한 환불 처리(환불 신청 후 7일~10일 소요)',
// 					},
// 				},
// 				{
// 					title: {
// 						...ulsTitleProps,
// 						children: '환불 금액',
// 						type: 'long',
// 					},
// 					content: {
// 						...ulsContentProps,
// 						children:
// 							'참가비의 10%를 제외한 금액(사무국 운영, 은행 수수료 등 제반 경비)',
// 					},
// 				},
// 			],
// 		},
// 	],
// };

export const schedule = {
	title: {
		text: {...cardTitleProps, children: '대회일정'},
	},
	table: {
		ths: [{}],
		trs: [[]],
		descriptions: [
			{
				content: {
					children: `위 일정은 행사장 상황에 따라 변동될 수 있습니다.`,
				},
			},
		],
	},
};
